import React, {  useState } from "react";
import {  NavLink, useParams } from "react-router-dom";
import Pagination from "@mui/material/Pagination";
import LinearProgress from "@mui/material/LinearProgress";
import Alert from "@mui/material/Alert";
import { useGetProductBySubCategoryIdQuery } from "../apis/VendorStore";
import { useDispatch } from "react-redux";
import { addToCart, setSelectedProductStore } from "../common/slices/productSlice"; 
import SearchLoader from "./SearchLoader";
const VendorsListDisplayTwoAmazon = () => {

  const dispatch = useDispatch();
   const [page, setPage] = useState(1);
  const pageSize = 12;

   const { id } = useParams(); // Extract vendor ID

  const {
    data: searchResults,
    error,
    isLoading,
    isFetching
  } =  useGetProductBySubCategoryIdQuery({
    subCategoriesId: id,
    page: page - 1,  // Convert to 0-based index for backend
    size: pageSize
  });
//console.log('searchResults',searchResults);

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };
   
  if (error) return <Alert severity="error">Error loading data: {error.message}</Alert>;
  if (isLoading) return <LinearProgress />;

  return (
    <section className='vendors-list py-20'>
            <SearchLoader/>

       <div className='container container-lg'>
        <div className='row gy-4'>
          <div>
            {/* Top Search */}
            <div className='flex-between flex-wrap gap-8 mb-40'>
             

              <div className='flex-align gap-16 mt-5'>
                {searchResults && (
                  <span className='text-neutral-600 fw-medium px-40 py-12 rounded-pill border border-neutral-100 d-md-block d-none'>
                    Showing {(page - 1) * pageSize + 1}-{Math.min(page * pageSize, searchResults.totalItems)} of {searchResults.totalItems} results
                  </span>
                )}
                </div>
            </div>

            {/* Products Start */}
            {isFetching && <LinearProgress />}

            <div className='mt-5 row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-3 row-cols-xl-4 row-cols-xxl-6 g-12'>
              {searchResults?.vendorStores?.map((product) => {
                const discountPrice = product.price && product.discount ? product.price * (1 - product.discount / 100) : product.price;

                return (
                  <div className='col' key={product.id}>
                    <div className='product-card h-100 p-8 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2'>
                      <NavLink
                        to="/product-detail-sample"
                        onClick={() => product && dispatch(setSelectedProductStore(product))}
                        className='product-card__thumb flex-center'
                      >
                        <img src={product.images?.[0] || "placeholder-image-url"} alt={product.name} />
                      </NavLink>
                      <div className='product-card__content p-sm-2 w-100'>
                        <h6 className='title text-lg fw-semibold mt-12 mb-8'>
                          <NavLink
                            to="/product-detail-sample"
                            onClick={() => product && dispatch(setSelectedProductStore(product))}
                            className='link text-line-2'
                          >
                            {product.name}
                          </NavLink>
                        </h6>
                        <div className='flex-align gap-4'>
                          <span className='text-main-600 text-md d-flex'>
                            <i className='ph-fill ph-storefront' />
                          </span>
                          <span className='text-gray-500 text-xs'>
                            {product.brand}
                          </span>
                        </div>
                        <div className='product-card__content mt-12'>
                          <div className='product-card__price mb-8'>
                            <span className='text-heading text-md fw-semibold '>
                              ${discountPrice.toFixed(2)}{" "}
                              <span className='text-gray-500 fw-normal'>/Qty</span>{" "}
                            </span>
                            {product.discount > 0 && (
                              <span className='text-gray-400 text-md fw-semibold text-decoration-line-through'>
                                ${product.price.toFixed(2)}
                              </span>
                            )}
                          </div>
                          <div className='flex-align gap-6'>
                            <span className='text-xs fw-bold text-gray-600'>
                              {product.ratings || 0}
                            </span>
                            <span className='text-15 fw-bold text-warning-600 d-flex'>
                              <i className='ph-fill ph-star' />
                            </span>
                          </div>
 
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Pagination */}
            {searchResults?.totalPages > 1 && (
              <div className="mt-40 flex-center">
                <Pagination
                  count={searchResults.totalPages}
                  page={page}
                  onChange={handlePageChange}
                  color="primary"
                  showFirstButton
                  showLastButton
                  sx={{
                    '& .MuiPaginationItem-root': {
                      borderRadius: '50%',
                      border: '1px solid #e5e7eb',
                      margin: '0 4px',
                      minWidth: '40px',
                      height: '40px'
                    },
                    '& .Mui-selected': {
                      backgroundColor: '#4f46e5',
                      color: '#fff',
                      borderColor: '#4f46e5'
                    }
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default VendorsListDisplayTwoAmazon;